import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { downloadFile, closeCollapsible, translate, formatDateToPtbr, getUserNameToName } from '../../../../utils/util';
import * as containerAction from '../../../../actions/containerAction';
import ContainerService from '../../../../services/ContainerService';
import ConfirmModal from '../../../../components/UI/ConfirmModal';
import { Breadcrumbs, Input, Button, Collapsible, Table } from '../../../../components/UI/ComponentsUI'
import { onValueChange } from '../../../../utils/handleChangeHooks';
import SelectNew from '../../../../components/UI/SelectNew';
import { ENUMS } from '../../../../utils/constants';
import { checkPermission } from '../../../../services/auth';
import { PERMISSIONS } from '../../../../utils/constants';

const ContainerList = (props) => {
    const messageModal = useRef();
    const [containers, setContainers] = useState([]);
    const [currentPage, setCurrentPage] = useState({ pageSize: 5, pageIndex: 0, sortField: "", sortOrder: 0 });
    const [selectedId, setSelectedId] = useState(undefined);
    const [selectedContainers, setSelectedContainers] = useState([])
    const [filter, setFilter] = useState({ internal: false });

    useEffect(() => {
        if (props.filters) {
            setFilter(props.filters);
        }

        if (!props.containerTypes) {
            props.getContainerTypes({ internal: false });
        }

        if (!props.containerSizes) {
            props.getContainerSizes({ internal: false });
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        setContainers(props.containers?.items || []);
        // eslint-disable-next-line
    }, [props?.containers?.items]);

    useEffect(() => {
        onSearch(false);
        // eslint-disable-next-line
    }, [currentPage]);

    const onSearch = (click) => {
        props.getContainers({
            ...filter,
            sortField: currentPage.sortField,
            sortOrder: currentPage.sortOrder,
            PageSize: currentPage.pageSize,
            PageIndex: click ? 0 : currentPage.pageIndex
        });

        closeCollapsible("filterLogs");
    }

    const openModal = (id) => {
        setSelectedId(id)
        messageModal.current.show();
    }

    const deleteSelectedContainer = () => {
        props.deleteContainer(selectedId, () => {
            messageModal.current.close();
            window.scrollTo(0, 0);
            if (currentPage > 0) {
                setCurrentPage(0)
            }
            setContainers([]);
        });
    };

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const deleteSelectedItems = () => {
        props.deleteSelected(selectedContainers, () => {
            setCurrentPage(0)
            onSearch()
        })
    }

    const onCheckItem = (item) => {
        let arr = [];
        Object.assign(arr, selectedContainers);
        let index = selectedContainers.findIndex((e) => e === item.id);
        if (index === -1) {
            arr.push(item.id)
        } else {
            arr.splice(index, 1);
        }
        setSelectedContainers(arr)
    }

    const exportCsv = () => {
        props.exportCsv(filter, (data) => {
            downloadFile(data, `container${Date.now()}.csv`, "data:text/csv", false);
        })
    }

    const onSelectItemChange = (item) => {
        props.setContainer(item);
        props.history.push({
            pathname: '../registercontainer/insert',
            state: { update: true }

        });
    };

    const configColumn = () => {
        const cols = [
            {
                field: 'id',
                header: "Id",
                align: 'left',
                sortable: false
            },
            {
                field: 'name',
                header: 'Nome Container',
                align: 'left',
                sortable: true
            },
            {
                field: 'statusDescription',
                header: 'Status',
                align: 'left',
                sortable: true
            },
            {
                field: 'containerTypeName',
                header: 'Tipo',
                align: 'left',
                sortable: true
            },
            {
                field: 'containerSizeName',
                header: 'Tamanho',
                align: 'left',
                sortable: true
            },
            {
                field: 'createdOn',
                body: (rowData) => formatDateToPtbr(rowData.createdOn),
                header: 'Data Criação',
                align: 'left',
                sortable: true
            },
            {
                field: 'createdBy',
                header: 'Criado Por',
                body: (rowData) => getUserNameToName(props?.usersFromElog, rowData.updatedBy || rowData.createdBy),
                align: 'left',
            }
        ];
        return cols;
    };

    const redirectStorageContainer = (item) => {

        props.history.push({
            state: {
                dataParams: item,
            },
            pathname: '../../storage/changestatus'
        });
    }

    const configActions = () => [
        {
            // size = 1 é interno
            function: (row) => (!row.type === 1 &&
                <i className="material-icons sixth-text-color"
                    onClick={() => onSelectItemChange(row)}
                    style={{ fontSize: '1.85rem', cursor: 'pointer', color: 'green' }}>edit</i>
            )
        },
        {
            function: (row) => (!row.type === 1 &&
                <i className="material-icons sixth-text-color"
                    onClick={() => openModal(row.id)}
                    style={{ fontSize: '1.85rem', cursor: 'pointer', color: 'red' }}>delete</i>
            )
        }, {
            function: (row) => (!row.type === 1 &&
                <Input
                    type="checkbox"
                    onChange={() => onCheckItem(row)}
                    id="select"
                    name="select"
                    checked={selectedContainers.find(f => f === row.id) || false}
                />
            )
        },{
                            function: (row) => (
                                (row.status === ENUMS.eContainerStatus.InYard.value || row.status === ENUMS.eContainerStatus.ReturnToYard.value) ? (
                                    <i
                                        className="mdi mdi-36px mdi-checkbox-marked-circle-outline gray-text"
                                        title="Armazenar Container"
                                        onClick={() => {
                                            redirectStorageContainer(row);
                                        }}
                                        style={{ fontSize: "1.85rem", cursor: "pointer", color: "green" }} >
                                    </i>
                                ) : null)

        }
    ];

    return (
        <div>
            <Breadcrumbs
                title={{ icon: "mdi mdi-view-dashboard-outline", label: "Container" }} />
            
            { checkPermission(PERMISSIONS.Warehouse_Container.Storage.Register) &&

                <i className={`mdi mdi-36px mdi-sticker-plus above-btn`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => props.history.push({ pathname: './insert' })} />
            }
            <i className={`mdi mdi-36px mdi-file-excel above-btn`}
                style={{ cursor: 'pointer' }}
                onClick={() => exportCsv()} />
            <div className="container-fluid" style={{ marginTop: '30px' }}>
                <div className="container" style={{ marginTop: '0px', }}>
                    <Collapsible
                        id="filterContainer"
                        header={translate('line-picking:linepicking.filter')}
                        body={
                            <>
                                <form id="getReport" className="col s12">
                                    <div className="row" style={{ padding: '10px' }}>
                                        <div className="input-field no-padding col s10">
                                            <Input
                                                id="name"
                                                name='name'
                                                label={translate('resource:name')}
                                                type="text"
                                                value={filter?.name || ''}
                                                onChange={onChange}
                                            />
                                        </div>

                                        <div className="input-field no-padding col s5">
                                            <SelectNew
                                                id="type"
                                                name="type"
                                                value={filter?.type || ''}
                                                change={onChange}
                                                placeHolder={translate('choose-one-option', 'general')}
                                                label={translate('fields.type', 'container')}
                                                data={props.containerTypes?.map((x) => ({ id: x.id, text: x.containerTypeName }))}
                                            />
                                        </div>
                                        <div className="input-field no-padding col s5">
                                            <SelectNew
                                                id="size"
                                                name="size"
                                                value={filter?.size || ''}
                                                change={onChange}
                                                placeHolder={translate('choose-one-option', 'general')}
                                                label={translate('fields.size', 'container')}
                                                data={props.containerSizes?.map((x) => ({ id: x.id, text: x.containerSizeName }))}
                                            />
                                        </div>
                                    </div>
                                </form>
                                <div className="row" style={{ paddingTop: '5px' }}>
                                    <Button full="true" text="Buscar" onClick={() => onSearch(true)} />
                                </div>
                            </>
                        }
                    />
                    {selectedContainers.length > 0 &&
                        <div className="row" style={{ paddingTop: '5px' }}>
                            <Button full="true" text="Excluir Selecionados" onClick={() => deleteSelectedItems()} />
                        </div>
                    }
                </div>
                <Table
                    totalPages={props.containers?.totalPages}
                    current={{ currentPage, setCurrentPage }}
                    col={configColumn()}
                    data={containers}
                    actions={configActions()} />
            </div>
            <ConfirmModal
                ref={messageModal}
                id="messageModalDelete"
                data={{ title: translate('validations:attention'), message: translate("token.confirmation-delete", "configuration") }}
                onConfirm={deleteSelectedContainer}
                btnCancel={translate('cancel', 'general')}
                btnConfirm={translate('confirm', 'general')}
            />
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        usersFromElog: state.usersElogReducer.usersElog,
        user: state.userReducer.user,
        filter: state.locationReducer.filter,
        containers: state.containerReducer.containers,
        filters: state.containerReducer.printFilters,
        containerTypes: state.containerReducer.containerTypes,
        containerSizes: state.containerReducer.containerSizes
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getContainers: (filter) => {
            dispatch(ContainerService.getContainerPaged(filter));
        },
        setContainer: (container) => {
            dispatch(containerAction.setContainer(container));
        },
        setContainerFilters: (filters) => {
            dispatch(containerAction.setContainerFilters(filters));
        },
        deleteContainer: (containerId, callback) => {
            dispatch(ContainerService.deleteContainer(containerId, callback));
        },
        exportCsv: (filter, callback) => {
            dispatch(ContainerService.exportContainerCsv(filter, callback));
        },
        getContainerTypes: (filter) => {
            dispatch(ContainerService.getContainerTypes(filter));
        },
        getContainerSizes: (filter) => {
            dispatch(ContainerService.getContainerSizes(filter));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ContainerList));
